var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHcIconMedicalCondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hc-icon-medical-condition_svg__Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33a3dc",
    d: "M147.91 185.23H33.11a6 6 0 01-6-6V21.81a6 6 0 016-6h116.21a6 6 0 016 6v63a6 6 0 11-11.95 0v-57H39.09v145.5h102.85V111a6 6 0 1111.95 0v68.3a6 6 0 01-5.98 5.93z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8ae15",
    d: "M123.44 161.84h-66.9a6 6 0 010-12h66.9a6 6 0 110 12zM98.69 136H56.54a6 6 0 010-11.95h42.15a6 6 0 110 11.95z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#33a3dc",
    d: "M112.26 121.27h-.47a6 6 0 01-5.27-4.29l-7.8-26.74-7.2 13.76a6 6 0 01-5.29 3.2H56.35a6 6 0 010-12h26.26L95 71.56a6 6 0 0111 1.1l7.54 25.86 4.58-9.68a6 6 0 015.4-3.42h43.32a6 6 0 010 12h-39.49l-9.69 20.49a6 6 0 01-5.4 3.36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8ae15",
    d: "M72.9 80.51H60.85A3.84 3.84 0 0157 76.67V72.9h-3.8a3.84 3.84 0 01-3.84-3.84V57a3.83 3.83 0 013.84-3.84H57v-3.8a3.84 3.84 0 013.84-3.84h12.04a3.84 3.84 0 013.84 3.84v3.78h3.81A3.84 3.84 0 0184.37 57v12.08a3.84 3.84 0 01-3.84 3.84h-3.79v3.75a3.84 3.84 0 01-3.84 3.84zm-8.21-7.68h4.37v-3.75a3.83 3.83 0 013.84-3.84h3.79v-4.43h-3.81A3.84 3.84 0 0169 57v-3.82h-4.35V57a3.84 3.84 0 01-3.84 3.84H57v4.4h3.81a3.84 3.84 0 013.84 3.84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHcIconMedicalCondition);
export default ForwardRef;